<template>
    <div class="proposal-table p-3">
        <b-table-simple responsive bordered v-if="financial_proposal">
            <b-thead>
                <b-tr>
                    <b-th>Type</b-th>
                    <b-th colspan="2" class="text-center">Price (RM)</b-th>
                </b-tr>
            </b-thead>
            <!-- Assets Start -->
            <b-tbody>
                <b-tr style="background: #FFF8B4;">
                    <b-td colspan="3">
                        <h3 class="mb-0">Assets</h3>
                    </b-td>
                </b-tr>
                <template v-if="financial_proposal.customer_assets">    
                    <!-- Cash/Cash Equivalents Start -->
                    <b-tr style="background: #FFFDEC;">
                        <b-td colspan="3">
                            <p class="font-weight-600">Cash/Cash Equivalents</p>
                        </b-td>
                    </b-tr>
                    <b-tr v-for="item in financial_proposal.customer_assets.cash_equivalents" :key="'cash_equivalents_'+item.customer_asset_id">
                        <b-td>{{ item.asset_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>{{ item.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600">
                        <b-td class="border-right-0">Total Cash/Cash Equi.</b-td>
                        <b-td class="border-right-0 border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.cash_equivalents.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.cash_equivalents.customer_value | moneyFormatter }}</p>
                        </b-td>
                        <b-td class="border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.cash_equivalents.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.cash_equivalents.admin_value | moneyFormatter }}</p>
                        </b-td>
                    </b-tr>
                    <!-- Cash/Cash Equivalents End -->
                    
                    <!-- Investment Assets Start -->
                    <b-tr style="background: #FFFDEC;">
                        <b-td colspan="3">
                            <p class="font-weight-600">Investment Assets</p>
                        </b-td>
                    </b-tr>
                    <b-tr v-for="item in financial_proposal.customer_assets.investment_assets" :key="'investment_assets_'+item.customer_asset_id">
                        <b-td>{{ item.asset_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>{{ item.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600">
                        <b-td class="border-right-0">Total Investment Assets</b-td>
                        <b-td class="border-right-0 border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.investment_assets.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.investment_assets.customer_value | moneyFormatter }}</p>
                        </b-td>
                        <b-td class="border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.investment_assets.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.investment_assets.admin_value | moneyFormatter }}</p>
                        </b-td>
                    </b-tr>
                    <!-- Investment Assets End -->

                    <!-- Personal Assets Start -->
                    <b-tr style="background: #FFFDEC;">
                        <b-td colspan="3">
                            <p class="font-weight-600">Personal Assets</p>
                        </b-td>
                    </b-tr>
                    <b-tr v-for="item in financial_proposal.customer_assets.personal_assets" :key="'personal_assets_'+item.customer_asset_id">
                        <b-td>{{ item.asset_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>{{ item.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600">
                        <b-td class="border-right-0">Total Personal Assets</b-td>
                        <b-td class="border-right-0 border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.personal_assets.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.personal_assets.customer_value | moneyFormatter }}</p>
                        </b-td>
                        <b-td class="border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.personal_assets.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.personal_assets.admin_value | moneyFormatter }}</p>
                        </b-td>
                    </b-tr>
                    <!-- Personal Assets End -->

                    <!-- EPF Account 1 Start -->
                    <b-tr style="background: #FFFDEC;">
                        <b-td colspan="3">
                            <p class="font-weight-600">EPF Account 1</p>
                        </b-td>
                    </b-tr>
                    <b-tr v-for="item in financial_proposal.customer_assets.epf_account_1" :key="'epf_account_1_'+item.customer_asset_id">
                        <b-td>{{ item.asset_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>{{ item.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600">
                        <b-td class="border-right-0">Total EPF Account 1</b-td>
                        <b-td class="border-right-0 border-left-0">{{ form_data_total.customer_assets.epf_account_1.customer_value | moneyFormatter }}</b-td>
                        <b-td class="border-left-0">{{ form_data_total.customer_assets.epf_account_1.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <!-- EPF Account 1 End -->

                    <!-- EPF Account 2 Start -->
                    <b-tr style="background: #FFFDEC;">
                        <b-td colspan="3">
                            <p class="font-weight-600">EPF Account 2</p>
                        </b-td>
                    </b-tr>
                    <b-tr v-for="item in financial_proposal.customer_assets.epf_account_2" :key="'epf_account_2_'+item.customer_asset_id">
                        <b-td>{{ item.asset_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>{{ item.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600">
                        <b-td class="border-right-0">Total EPF Account 2</b-td>
                        <b-td class="border-right-0 border-left-0">{{ form_data_total.customer_assets.epf_account_2.customer_value | moneyFormatter }}</b-td>
                        <b-td class="border-left-0">{{ form_data_total.customer_assets.epf_account_2.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <!-- EPF Account 2 End -->

                    <!-- Insurances Start -->
                    <b-tr style="background: #FFFDEC;">
                        <b-td colspan="3">
                            <p class="font-weight-600">Insurances</p>
                        </b-td>
                    </b-tr>
                    <b-tr v-for="item in financial_proposal.customer_assets.insurances" :key="'insurances_'+item.customer_asset_id">
                        <b-td>{{ item.asset_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>{{ item.admin_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600">
                        <b-td class="border-right-0">Total Insurances</b-td>
                        <b-td class="border-right-0 border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.insurances.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.insurances.customer_value | moneyFormatter }}</p>
                        </b-td>
                        <b-td class="border-left-0">
                            <p class="font-weight-600" :style="{'color': form_data_total.customer_assets.insurances.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.customer_assets.insurances.admin_value | moneyFormatter }}</p>
                        </b-td>
                    </b-tr>
                    <!-- Insurances End -->

                    <b-tr>
                        <b-td class="border-right-0">
                            <h3 class="mb-0">Total Assets</h3>
                        </b-td>
                        <b-td class="border-right-0 border-left-0">
                            <h3 class="mb-0">{{ form_data_total.customer_assets.total_asset_customer_value | moneyFormatter }}</h3>
                        </b-td>
                        <b-td class="border-left-0">
                            <h3 class="mb-0">{{ form_data_total.customer_assets.total_asset_admin_value | moneyFormatter }}</h3>
                        </b-td>
                    </b-tr>
                    <!-- Assets End -->
                </template>
                <!-- Liabilities Start -->
                <b-tr style="background: #FFF8B4;">
                    <b-td colspan="3">
                        <h3 class="mb-0">Liabilities</h3>
                    </b-td>
                </b-tr>

                <!-- Current Liabilities Start -->
                <b-tr style="background: #FFFDEC;">
                    <b-td colspan="3">
                        <p class="font-weight-600">Current Liabilities</p>
                    </b-td>
                </b-tr>
                <b-tr v-for="item in financial_proposal.customer_liabilities" :key="'current_liability_'+item.customer_liability_id">
                    <template v-if="item.loan_statue != 'PCPASCAR' && item.loan_statue != 'HSLNFNCE'">
                        <b-td class="custom-width">{{ item.loan_statue_name }}</b-td>
                        <b-td>{{ item.customer_curr_outstanding | moneyFormatter }}</b-td>
                        <b-td>
                            <CurrencyInput
                                v-model="item.admin_curr_outstanding"
                                v-on:input="updateData(item.customer_liability_id, item.admin_curr_outstanding)"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                :style="{...getInputStyle(item.admin_curr_outstanding ,  item.customer_curr_outstanding), color:  'black' , fontWeight:'bold'}"
                                />
                        </b-td>
                    </template>
                </b-tr>
                <b-tr>
                    <b-td class="border-right-0">
                        <p class="font-weight-600">Total Current Liabilities</p>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_liabilities.current_liabilities.customer_value | moneyFormatter }}</p>
                    </b-td>
                    <b-td class="border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_liabilities.current_liabilities.admin_value | moneyFormatter }}</p>
                    </b-td>
                </b-tr>
                <!-- Current Liabilities End -->

                <!-- Long Term Liabilities Start -->
                <b-tr style="background: #FFFDEC;">
                    <b-td colspan="3">
                        <p class="font-weight-600">Long Term Liabilities</p>
                    </b-td>
                </b-tr>
                <b-tr v-for="item in financial_proposal.customer_liabilities" :key="'long_term_liability_'+item.customer_liability_id">
                    <template v-if="item.loan_statue == 'PCPASCAR' || item.loan_statue == 'HSLNFNCE'">
                        <b-td class="custom-width">{{ item.loan_statue_name }}</b-td>
                        <b-td>{{ item.customer_curr_outstanding | moneyFormatter }}</b-td>
                        <b-td>
                            <CurrencyInput
                                v-model="item.admin_curr_outstanding"
                                v-on:input="updateData(item.customer_liability_id, item.admin_curr_outstanding)"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"

                            />
                        </b-td>
                    </template>
                </b-tr>
                <b-tr>
                    <b-td class="border-right-0">
                        <p class="font-weight-600">Total Long Term Liabilities</p>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_liabilities.long_term_liabilities.customer_value | moneyFormatter }}</p>
                    </b-td>
                    <b-td class="border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_liabilities.long_term_liabilities.admin_value | moneyFormatter }}</p>
                    </b-td>
                </b-tr>
                <!-- Long Term Liabilities End -->

                <b-tr>
                    <b-td class="border-right-0">
                        <h3 class="mb-0">Total Liabilities</h3>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <h3 class="mb-0">{{ form_data_total.total_liabilities.customer_value | moneyFormatter }}</h3>
                    </b-td>
                    <b-td class="border-left-0">
                        <h3 class="mb-0">{{ form_data_total.total_liabilities.admin_value | moneyFormatter }}</h3>
                    </b-td>
                </b-tr>
                <!-- Liabilities End -->
            </b-tbody>

            <b-tfoot>
                <b-tr>
                    <b-td class="border-right-0">
                        <h2 class="mb-0 font-weight-700">Net Worth</h2>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <h2 class="mb-0 font-weight-700" :style="{'color': form_data_total.net_worth.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.net_worth.customer_value | moneyFormatter }}</h2>
                    </b-td>
                    <b-td class="border-left-0">
                        <h2 class="mb-0 font-weight-700" :style="{'color': form_data_total.net_worth.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.net_worth.admin_value | moneyFormatter }}</h2>
                    </b-td>
                </b-tr>
            </b-tfoot>
        </b-table-simple>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { axios, services, getHeader, notifyFunctionMixin, debounce } from '@/assets/js/httpImports.js'

export default {
    props: ['financial_proposal'],
    // props: {
    //     financial_proposal: {
    //         validator: function (value) {
    //             // Check if the value is either an object or an array
    //             return (
    //                 (typeof value === 'object' && !Array.isArray(value)) || Array.isArray(value)
    //             );
    //         },
    //         default: () => ({
    //             // Provide default values for the properties you'll access
    //             customer_incomes: {
    //                 data: [],
    //                 total: [],
    //             },
    //             customer_assets: {
    //                 cash_equivalents: [],
    //                 investment_assets: [],
    //                 personal_assets: [],
    //                 epf_account_1: [],
    //                 epf_account_2: [],
    //                 insurances: [],
    //             },
    //             // Other top-level properties with default values
    //         }),
    //     },
    // },
    mixins: [notifyFunctionMixin],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        CurrencyInput,
    },
    data() {
        return {
            form_data_total: {
                customer_liabilities: {
                    current_liabilities: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    long_term_liabilities: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    total_liabilities: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                },
                customer_assets: {
                    cash_equivalents: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    investment_assets: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    personal_assets: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    epf_account_1: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    epf_account_2: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    insurances: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                    total_asset_customer_value: 0,
                    total_asset_admin_value: 0,
                },
                net_worth: {
                    customer_value: 0,
                    admin_value: 0,
                },
            }
        }
    },
    computed: {
    },
    watch: {
    'financial_proposal.customer_assets': {
        handler(newVal) {
            if (newVal) {
                const customer_assets = this.financial_proposal.customer_assets;

                const overrideAdminValue = (assets) => {
                    assets.forEach(item => {
                        if (item.admin_value === null || item.admin_value === 0) {
                            item.admin_value = item.customer_value;
                        }
                    });
                };

                if (customer_assets.cash_equivalents.length > 0) {
                    overrideAdminValue(customer_assets.cash_equivalents);
                    this.form_data_total.customer_assets.cash_equivalents = {
                        customer_value: customer_assets.cash_equivalents.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: customer_assets.cash_equivalents.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }

                if (customer_assets.investment_assets.length > 0) {
                    overrideAdminValue(customer_assets.investment_assets);
                    this.form_data_total.customer_assets.investment_assets = {
                        customer_value: customer_assets.investment_assets.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: customer_assets.investment_assets.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }

                if (customer_assets.personal_assets.length > 0) {
                    overrideAdminValue(customer_assets.personal_assets);
                    this.form_data_total.customer_assets.personal_assets = {
                        customer_value: customer_assets.personal_assets.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: customer_assets.personal_assets.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }

                if (customer_assets.epf_account_1.length > 0) {
                    let epfAccount1 = customer_assets.epf_account_1[0];
                    if (epfAccount1.admin_value === null || epfAccount1.admin_value === 0) {
                        epfAccount1.admin_value = epfAccount1.customer_value;
                    }
                    this.form_data_total.customer_assets.epf_account_1 = {
                        customer_value: epfAccount1.customer_value,
                        admin_value: epfAccount1.admin_value,
                    };
                }

                if (customer_assets.epf_account_2.length > 0) {
                    let epfAccount2 = customer_assets.epf_account_2[0];
                    if (epfAccount2.admin_value === null || epfAccount2.admin_value === 0) {
                        epfAccount2.admin_value = epfAccount2.customer_value;
                    }
                    this.form_data_total.customer_assets.epf_account_2 = {
                        customer_value: epfAccount2.customer_value,
                        admin_value: epfAccount2.admin_value,
                    };
                }

                if (customer_assets.insurances.length > 0) {
                    overrideAdminValue(customer_assets.insurances);
                    this.form_data_total.customer_assets.insurances = {
                        customer_value: customer_assets.insurances.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: customer_assets.insurances.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }
            }
        },
        deep: true,
    },
    'form_data_total.customer_assets': {
        handler(newVal) {
            if (newVal) {
                const total_customer_value = Object.entries(newVal).reduce((total, [key, asset]) => {
                    return key !== 'total_asset_customer_value' && key !== 'total_asset_admin_value' ? total + asset.customer_value : total;
                }, 0);
                const total_admin_value = Object.entries(newVal).reduce((total, [key, asset]) => {
                    return key !== 'total_asset_customer_value' && key !== 'total_asset_admin_value' ? total + asset.admin_value : total;
                }, 0);

                // calculate total assets
                this.form_data_total.customer_assets.total_asset_customer_value = total_customer_value;
                this.form_data_total.customer_assets.total_asset_admin_value = total_admin_value;

                this.calculateNetWorth();
            }
        },
        immediate: true,
        deep: true,
    },
    'financial_proposal.customer_liabilities': {
        handler(newVal) {
            if (newVal) {

                if (this.financial_proposal.customer_liabilities.length > 0) {
                    this.form_data_total.customer_liabilities.current_liabilities = {
                        customer_value: this.financial_proposal.customer_liabilities.reduce((acc, item) => {
                            return item.loan_statue != 'PCPASCAR' && item.loan_statue != 'HSLNFNCE' ? acc + item.customer_curr_outstanding : acc;
                        }, 0),
                        admin_value: this.financial_proposal.customer_liabilities.reduce((acc, item) => {
                            return item.loan_statue != 'PCPASCAR' && item.loan_statue != 'HSLNFNCE' ? acc + item.admin_curr_outstanding : acc;
                        }, 0),
                    };

                    this.form_data_total.customer_liabilities.long_term_liabilities = {
                        customer_value: this.financial_proposal.customer_liabilities.reduce((acc, item) => {
                            return item.loan_statue == 'PCPASCAR' || item.loan_statue == 'HSLNFNCE' ? acc + item.customer_curr_outstanding : acc;
                        }, 0),
                        admin_value: this.financial_proposal.customer_liabilities.reduce((acc, item) => {
                            return item.loan_statue == 'PCPASCAR' || item.loan_statue == 'HSLNFNCE' ? acc + item.admin_curr_outstanding : acc;
                        }, 0),
                    };
                }
                this.calculateNetWorth();
            }
        },
        immediate: true,
        deep: true,
    }
},

    methods: {
      getInputStyle(admin_value , customer_value) {
            return admin_value != customer_value
                ? 'background-color: lightblue'
                : 'background-color: transparent';
        },
        replaceNullWithZero(obj) {
            for (const key in obj) {
                if (obj[key] === null) {
                    obj[key] = 0;
                } else if (typeof obj[key] === 'object') {
                    this.replaceNullWithZero(obj[key]);
                } else if (typeof obj[key] === 'number' && isNaN(obj[key])) {
                    obj[key] = 0;
                }
            }
        },
        calculateNetWorth() {
            this.replaceNullWithZero(this.form_data_total);
            // total liabilities
            this.form_data_total.total_liabilities = {
                customer_value: this.form_data_total.customer_liabilities.current_liabilities.customer_value + this.form_data_total.customer_liabilities.long_term_liabilities.customer_value,
                admin_value: this.form_data_total.customer_liabilities.current_liabilities.admin_value + this.form_data_total.customer_liabilities.long_term_liabilities.admin_value,
            }

            const total_customer_liabilities = this.form_data_total.total_liabilities.customer_value;
            const total_admin_liabilities = this.form_data_total.total_liabilities.admin_value;

            // calculate net worth when the assets is changed
            this.form_data_total.net_worth = {
                customer_value: this.form_data_total.customer_assets.total_asset_customer_value - total_customer_liabilities,
                admin_value: this.form_data_total.customer_assets.total_asset_admin_value - total_admin_liabilities,
            }
        },
        updateData: debounce(function(customer_liability_id, curr_outstanding) {
            const postData = {
                admin_curr_outstanding : curr_outstanding,
            }
            axios.put(services.financial_proposal + 'customer_liability/' + customer_liability_id, postData, { headers: getHeader() })
            .then(response => {
                // this.generateChart();
            })
            .catch ( error => {
                // console.log(error.response.status)
                this.errorFunction(error, "Error Saving Admin Value") 
            });
        },1000),
    },
}
</script>